<template>
    <div v-if="!$store.state.waitingRequest">
        <main>
            <h1>Résultats pour "{{ $route.params.search }}"</h1>
            <p class="gamesNumber">{{ foundGames.length }} {{ foundGames.length > 1 ? 'jeux trouvés' : 'jeu trouvé' }} ! <i></i></p>

            <section>
                <div class="all-games" v-if="foundGames.length > 0">
                    <div class="jeu-container" v-for="game in foundGames" :key="game.id">
                        <div class="jeu">
                            <div class="ribbon-new-container" v-if="(((nowDate - (new Date(game.created_at.replace(/-/g, '/')).getTime()/1000))/3600).toFixed(2)) <= 72.00">
                                <div class="ribbon-new">NOUVEAU</div>
                            </div>

                            <router-link :to="'/' + game.title_url" :title="game.title">
                                <div class="img"><div class="background" :style="{'background-image' : 'url(\'/games/static/miniatures/' + game.image_url + '\')'}"></div></div>
                                <div class="contenu">
                                    <p>{{ game.title }}</p>
                                    <span>Joué {{ game.view_count }} fois</span>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
                <h2 v-if="foundGames.length == 0">Aucun résultat</h2>
            </section>

            <div class="ad-banner">
                <ins class="adsbygoogle"
                data-ad-client="ca-pub-2512331316053279"
                data-ad-slot="6346220535"></ins>
            </div>
        </main>
    </div>
</template>

<script>
    import AddGoogleScripts from '../mixins/addGoogleScripts';

    export default {
        mixins: [AddGoogleScripts],
        data() {
            return {
                nowDate: null,

                foundGames: [],

                metas : {
                    title: 'Résultats de la recherche | Games par ClickTestCPS',
                    meta: [
                        {
                            name: 'robots',
                            content: 'none'
                        },
                        {
                            property: 'og:image',
                            content: 'https://clicktestcps.fr/og-games.png'
                        },
                        {
                            property: 'og:title',
                            content: 'Jeux en ligne gratuits en un clic - Jeu FR '+new Date().getFullYear()+' sans inscription - Games™ par ClickTestCPS'
                        },
                        {
                            property: 'og:description',
                            content: 'Jouez à des centaines de jeux en ligne gratuitement et sans inscription. Une sélection unique de jeux en ligne gratuits alimentée quotidiennement'
                        }
                    ]
                }
            }
        },
        mounted() {
            useHead(this.metas);

            this.$store.commit('setRequestTrue');

            this.getGames();

            this.nowDate = new Date().getTime()/1000;
        },
        methods: {
            getGames() {
                let formData = new FormData();
                formData.append('data', JSON.stringify({post: "1", search: this.$route.params.search}));

                axios
                .post(
                this.$store.state.apiUrl+"?request=searchAllGames", formData
                )
                .then((response) => {
                    if(response.data.length > 0) {
                        this.foundGames = response.data;
                    }
                })
                .finally(() => {
                    this.$store.commit('setRequestFalse');
                });
            }
        }
    }
</script>

<style scoped src="@/assets/categorie.css">
</style>
